import { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import { UserContext } from 'contexts/user';
import { getCounts } from 'api/counts';

import AdminMenu from './menu/admin';

import ProfileItem from './profile_item';

import './aside.scss';

const Aside = ({ updateCount, onSignOut }) => {
  const { user } = useContext(UserContext);
  const [showDropdown, setShowDropdown] = useState(false);
  const [polysomnographies, setPolysomnographies] = useState();
  const [polygraphies, setPolygraphies] = useState();
  const [nurseTeleconsultations, setNurseTeleconsultations] = useState();
  const [tasks, setTasks] = useState();
  const [treatments, setTreatments] = useState();
  const [firstTeleconsultations, setFirstTeleconsultations] = useState();
  const [secondTeleconsultations, setSecondTeleconsultations] = useState();
  const [renewals, setRenewals] = useState();

  useEffect(() => {
    (async () => {
      const {
        polygraphies,
        polysomnographies,
        nurseTeleconsultations,
        tasks,
        treatments,
        firstTeleconsultations,
        secondTeleconsultations,
        renewals,
      } = await getCounts();

      setPolygraphies(polygraphies);
      setPolysomnographies(polysomnographies);
      setNurseTeleconsultations(nurseTeleconsultations);
      setTasks(tasks);
      setTreatments(treatments);
      setFirstTeleconsultations(firstTeleconsultations);
      setSecondTeleconsultations(secondTeleconsultations);
      setRenewals(renewals);
    })();
  }, [updateCount]);

  if (!user) return null;
  if (user.role !== 'admin') return null;

  return (
    <nav className="th-nav">
      <header className="th-nav-menu">
        <div className="th-nav-menu-details">
          <div className="th-nav-menu-icon">
            <img src="/logo.png" alt="logo" />
          </div>
        </div>
      </header>
      <AdminMenu
        nurseTeleconsultationsCount={nurseTeleconsultations}
        polygraphiesCount={polygraphies}
        polysomnographiesCount={polysomnographies}
        tasksCount={tasks}
        treatmentsCount={treatments}
        firstTeleconsultationsCount={firstTeleconsultations}
        secondTeleconsultationsCount={secondTeleconsultations}
        renewalsCount={renewals}
      >
        <div>
          <ProfileItem
            arrowUp={showDropdown}
            avatarUrl={user.avatar}
            onClick={() => setShowDropdown(!showDropdown)}
            onClickOutside={() => setShowDropdown(false)}
            onSignOut={onSignOut}
            showDropdown={showDropdown}
          />
        </div>
      </AdminMenu>
    </nav>
  );
};

Aside.propTypes = {
  onSignOut: PropTypes.func.isRequired,
  updateCount: PropTypes.bool.isRequired,
};

export default Aside;
